import { FC, ImgHTMLAttributes } from 'react'
import { generatePictureSources } from 'project/image-proxy-web'

type PictureImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'srcSet'
> & {
  imageSrc: string | { default: { src: string } }
  width: number
  height: number
  dpiSteps?: number[]
}

const PictureImage: FC<PictureImageProps> = ({
  dpiSteps,
  height,
  imageSrc,
  width,
  ...imgProps
}) => {
  const { sources, src, srcSet } = generatePictureSources(
    imageSrc,
    width,
    height,
    dpiSteps,
  )

  if (!sources.length) {
    return <img src={src} width={width} height={height} {...imgProps} />
  }

  return (
    <picture>
      {sources.map((source) => (
        <source key={source.type} type={source.type} srcSet={source.srcSet} />
      ))}
      <img
        src={src}
        srcSet={srcSet}
        width={width}
        height={height}
        {...imgProps}
      />
    </picture>
  )
}

export default PictureImage
